"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

var _PopperContainer = _interopRequireDefault(require("./PopperContainer"));

var _popsOver = _interopRequireDefault(require("../../util/behaviors/popsOver"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @typedef Popover.renderPopoverChildren
 * @param {object} props
 * @param {function} props.onToggle
 */

/**
 * @class Popover
 * @desc Popover creates a trigger component that controls the visibility of the content.
 *
 * @param {string} [data-id="popover"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {node|Popover.renderPopoverChildren} [children]
 *     Children can be passed as usual or as a function that renders the
 *     children with the provided onToggle callback.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 * @param {string} [triggerClassName]
 *     CSS classes to set on the link that triggers the popover.
 *
 * @param {object|string} [label]
 *     A string or JSX object that serves as the trigger label.
 *
 * @param {string} [placement]
 *     Placement using keywords top, left, right. (Default is bottom center)
 *
 * @param {boolean} [padded=false]
 *     If true, the content will be padded from the frame.
* @param {bool} [noHoverEffect=false]
 *     If there should be a hover effect
 * @param {boolean} [open=false]
 *     If true, tooltip is open or else closed.
 * @param {function} [onToggle]
 *     Callback to be triggered when trigger is clicked.
 * @param {function} [onPopperClick]
 *     If using a portal, the callback that's triggered then the PopperContainer is clicked
 * @param {string} [popperClassName]
 *     If using a portal, a className that's added to the PopperContainer
 */
var PopoverBase = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(PopoverBase, _React$Component);

  var _super = _createSuper(PopoverBase);

  function PopoverBase() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, PopoverBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_hasPlacement", function (word) {
      return _this.props.placement && _this.props.placement.search(word) >= 0;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getModifiers", function (block) {
      var modifiers = {};
      modifiers["".concat(block, "--top")] = _this._hasPlacement("top");
      modifiers["".concat(block, "--left")] = _this._hasPlacement("left");
      modifiers["".concat(block, "--right")] = _this._hasPlacement("right");
      return modifiers;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderContent", function () {
      var _this$props = _this.props,
          _this$props$children = _this$props.children,
          children = _this$props$children === void 0 ? null : _this$props$children,
          onToggle = _this$props.onToggle;

      if (typeof children === "function") {
        return children({
          onToggle: onToggle
        });
      }

      return children;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_content", function () {
      var _React$createElement;

      if (!_this.props.open) {
        return null;
      }

      var frameClassName = (0, _classnames.default)("popup-frame", _this.props.className, _this._getModifiers("popup-frame"), {
        "popup-frame--padded": _this.props.padded
      });

      var contents = /*#__PURE__*/_react.default.createElement("div", {
        className: frameClassName
      }, _this.renderContent());

      var positionList = _this.props.placement.split(" ");

      var getHorizontalPlacement = function getHorizontalPlacement(vertical) {
        if ((0, _find.default)(_underscore.default).call(_underscore.default, positionList, function (v) {
          return v === "left";
        })) {
          return vertical + "-end";
        } else if ((0, _find.default)(_underscore.default).call(_underscore.default, positionList, function (v) {
          return v === "center";
        })) {
          return vertical;
        } else {
          return vertical + "-start";
        }
      };

      var getPlacement = function getPlacement() {
        if ((0, _find.default)(_underscore.default).call(_underscore.default, positionList, function (v) {
          return v === "top";
        })) {
          return getHorizontalPlacement("top");
        } else {
          return getHorizontalPlacement("bottom");
        }
      };

      return /*#__PURE__*/_react.default.createElement(_PopperContainer.default, (_React$createElement = {
        "data-parent": _this.props["data-id"],
        className: (0, _classnames.default)("popover-display", _this.props.popperClassName),
        "data-id": "popup-frame"
      }, (0, _defineProperty2.default)(_React$createElement, "data-parent", _this.props["data-id"]), (0, _defineProperty2.default)(_React$createElement, "getReference", _this._getReference), (0, _defineProperty2.default)(_React$createElement, "pointerClassName", "popup-frame__pointer"), (0, _defineProperty2.default)(_React$createElement, "placement", getPlacement()), (0, _defineProperty2.default)(_React$createElement, "ref", function ref(el) {
        return _this.popperContainer = el;
      }), (0, _defineProperty2.default)(_React$createElement, "onClick", _this.props.onPopperClick), _React$createElement), contents);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getReference", function () {
      return _this.reference;
    });
    return _this;
  }

  (0, _createClass2.default)(PopoverBase, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var containerClassName = (0, _classnames.default)("popover", this.props.className, this._getModifiers("popover"), "popover--use-portal");
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClassName,
        "data-id": this.props["data-id"]
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: (0, _classnames.default)("popover__trigger", this.props.triggerClassName, {
          active: this.props.open,
          "popover__trigger--no-hover": this.props.noHoverEffect
        }),
        "data-id": "".concat(this.props["data-id"], "-trigger"),
        onClick: this.props.onToggle,
        onKeyDown: this.props.onKeyDown,
        title: this.props.title,
        ref: function ref(el) {
          return _this2.reference = el;
        }
      }, this.props.label), this._content());
    }
  }]);
  return PopoverBase;
}(_react.default.Component);

(0, _defineProperty2.default)(PopoverBase, "displayName", "Popover");
(0, _defineProperty2.default)(PopoverBase, "propTypes", {
  "data-id": _propTypes.default.string,
  "data-parent": _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  className: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  onPopperClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onToggle: _propTypes.default.func,
  padded: _propTypes.default.bool,
  noHoverEffect: _propTypes.default.bool,
  open: _propTypes.default.bool,
  placement: _propTypes.default.string,
  triggerClassName: _propTypes.default.string,
  popperClassName: _propTypes.default.string
});
(0, _defineProperty2.default)(PopoverBase, "defaultProps", {
  "data-id": "popover",
  label: "Link",
  onPopperClick: _underscore.default.noop,
  onKeyDown: _underscore.default.noop,
  onToggle: _underscore.default.noop,
  noHoverEffect: false,
  placement: "",
  triggerClassName: "",
  popperClassName: "",
  padded: false
});
var Popover = (0, _popsOver.default)(PopoverBase);
Popover.Base = PopoverBase;
module.exports = Popover;